<div class="px-4 py-4">
  <p class="mb-3 text-xs font-semibold uppercase tracking-wide text-gray-400">
    Payment History
  </p>
  @if (loading()) {
  <p class="text-sm text-gray-500">Loading payments...</p>
  } @else {
  <div class="overflow-x-auto rounded-md border border-gray-200">
    <table class="min-w-full divide-y divide-gray-200 text-sm">
      <thead class="bg-slate-600 text-slate-100">
        <tr>
          <th class="p-3 text-left">Payment #</th>
          <th class="p-3 text-left">Date</th>
          <th class="p-3 text-left">Method</th>
          <th class="p-3 text-left">Reference</th>
          <th class="p-3 text-right">Amount</th>
          <th class="p-3 text-left">Type</th>
          @if (canReversePayment()) {
          <th class="p-3 text-slate-100">
            <span class="sr-only">Actions</span>
          </th>
          }
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200">
        @for (payment of payments(); track payment.id) {
        <tr class="hover:bg-gray-50">
          <td class="p-3 font-mono text-xs whitespace-nowrap">
            {{ payment.document_number }}
          </td>
          <td class="p-3 whitespace-nowrap">
            {{ formatDate(payment.payment_date) }}
          </td>
          <td class="p-3 whitespace-nowrap">
            {{ titleCase(payment.payment_method) }}
          </td>
          <td class="p-3 font-mono text-xs">
            {{ payment.payment_reference }}
          </td>
          <td
            class="p-3 text-right whitespace-nowrap font-semibold"
            [class]="
              payment.type === 'reversal' ? 'text-red-600' : 'text-green-700'
            "
          >
            {{ payment.type === 'reversal' ? '-' : ''
            }}{{ formatMoney(payment.amount_minor, payment.currency) }}
          </td>
          <td class="p-3">
            <span
              class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
              [class]="
                payment.type === 'reversal'
                  ? 'bg-red-100 text-red-700'
                  : payment.type === 'adjustment'
                  ? 'bg-blue-100 text-blue-700'
                  : 'bg-green-100 text-green-700'
              "
            >
              {{ titleCase(payment.type) }}
            </span>
          </td>
          @if (canReversePayment()) {
          <td class="p-3 text-right">
            @if (payment.type === 'payment') {
            <button
              type="button"
              class="text-xs text-red-600 hover:text-red-800 hover:underline"
              (click)="reversePayment.emit(payment.id)"
            >
              Reverse
            </button>
            }
          </td>
          }
        </tr>
        } @empty {
        <tr>
          <td [attr.colspan]="canReversePayment() ? 7 : 6">
            <shared-no-records-placeholder
              title="No payments recorded"
              description="Payments will appear here once recorded."
            />
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>
